import { LISTS, LISTS_TRACKER_NAMESPACE } from '../constants/namespaces';
import enviro from 'enviro';
import { createTracker } from 'usage-tracker';
import once from '../utils/once';
import { CRM_USAGE_TRACKER_EVENT_NAME_MAP } from '../constants/eventNames';
const trackerArgs = {
  properties: {
    namespace: LISTS
  },
  onError(err) {
    console.error(err);
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  debug: () => enviro.debug('customer-data-tracker'),
  standalone: true
};
export const getTracker = once(() => createTracker(trackerArgs));
export const getTrackerSendImmediate = once(() => createTracker(Object.assign({
  bypassPool: true
}, trackerArgs)));

/**
 * @deprecated Use the usage-tracker library's createTracker with a standalone flag set to true instead.
 * There no longer is a need to use a shared tracking library since events.yamls are unused and will soon be deleted.
 * https://product.hubteam.com/docs/usage-tracking-manual/docs/frontend/tracker-api.html#configuration-options
 */
export const ListsLogger = {
  init: data => {
    getTracker().setProperties(data);
    getTrackerSendImmediate().setProperties(data);
  },
  logImmediate: (eventName, eventProps = {}, trackerOptions = {}) => {
    ListsLogger.log(eventName, eventProps, Object.assign({}, trackerOptions, {
      sendImmediate: true
    }));
  },
  log: (eventName, eventProps = {}, trackerOptions = {
    sendImmediate: false
  }) => {
    ListsLogger._log(eventName, eventProps, trackerOptions);
  },
  _log(eventName = '', eventProps = {}, trackerOptions = {
    sendImmediate: false
  }) {
    const {
      sendImmediate = false
    } = trackerOptions;
    const tracker = sendImmediate ? getTrackerSendImmediate() : getTracker();
    const eventNameMap = CRM_USAGE_TRACKER_EVENT_NAME_MAP.lists;
    const mappedEventName = eventNameMap[eventName] || eventName;
    tracker.track(LISTS_TRACKER_NAMESPACE, mappedEventName, eventProps);
  }
};
export default ListsLogger;